import { useState } from "react"
import { useTranslation } from "react-i18next"
import { PullSheetApi } from "../../apis"
import { message } from "../../utils/message"

/**
 * Opens a pull sheet PDF. A cached file (`cachedUrl`) opens at once; `regenerate` asks the backend to
 * build it again (loaded quantities may have changed since the first file was made).
 */
export function usePullSheetPdf() {
  const { t } = useTranslation("delivery")
  const [loadingId, setLoadingId] = useState<string | null>(null)

  const open = async (id: string, options: { cachedUrl?: string | null; regenerate?: boolean } = {}) => {
    if (!id || loadingId) return
    if (options.cachedUrl && !options.regenerate) {
      window.open(options.cachedUrl, "_blank", "noopener,noreferrer")
      return
    }
    try {
      setLoadingId(id)
      const res = await PullSheetApi.pdf(id, !!options.regenerate)
      if (res?.url) {
        window.open(res.url, "_blank", "noopener,noreferrer")
      } else {
        message.error(t("pullSheet.pdfError"))
      }
    } catch (err: any) {
      message.error(err?.message || t("pullSheet.pdfError"))
    } finally {
      setLoadingId(null)
    }
  }

  return { open, loadingId }
}
